(() => {
  const symbol = '®';
  const className = 'registered-mark';
  const skipSelector = [
    'script',
    'style',
    'textarea',
    'select',
    'option',
    'pre',
    'code',
    'svg',
    `sup.${className}`,
    '[data-registered-mark-ignore]',
  ].join(',');

  const shouldReplace = (textNode) => {
    if (!textNode?.nodeValue?.includes(symbol)) return false;

    const parent = textNode.parentElement;
    return Boolean(parent && !parent.closest(skipSelector));
  };

  const replaceTextNode = (textNode) => {
    if (!shouldReplace(textNode)) return;

    const parts = textNode.nodeValue.split(symbol);
    const fragment = document.createDocumentFragment();

    parts.forEach((part, index) => {
      if (part) fragment.append(document.createTextNode(part));

      if (index < parts.length - 1) {
        const registeredMark = document.createElement('sup');
        registeredMark.className = className;
        registeredMark.textContent = symbol;
        fragment.append(registeredMark);
      }
    });

    textNode.replaceWith(fragment);
  };

  const replaceWithin = (root) => {
    if (root.nodeType === Node.TEXT_NODE) {
      replaceTextNode(root);
      return;
    }

    if (!(root instanceof Element || root instanceof Document)) return;

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: (textNode) =>
          shouldReplace(textNode)
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT,
      }
    );

    const matches = [];
    while (walker.nextNode()) matches.push(walker.currentNode);
    matches.forEach(replaceTextNode);
  };

  const initialize = () => {
    replaceWithin(document.body);

    const pendingRoots = new Set();
    let frame;

    const flush = () => {
      pendingRoots.forEach(replaceWithin);
      pendingRoots.clear();
      frame = undefined;
    };

    const queue = (node) => {
      pendingRoots.add(node);
      if (!frame) frame = window.requestAnimationFrame(flush);
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') queue(mutation.target);
        mutation.addedNodes.forEach(queue);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    document.addEventListener('shopify:section:load', (event) => {
      replaceWithin(event.target);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
